import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeMenu: "/store",
};

const setupSlice = createSlice({
  name: "setupSlice",
  initialState,
  reducers: {
    changeActiveMenu: (state, actions) => {
      state.activeMenu = actions?.payload;
    },
  },
});

export const { getSetupSuccess, changeActiveMenu } = setupSlice.actions;

export default setupSlice.reducer;
